import { render, staticRenderFns } from "./CustomSortButton.vue?vue&type=template&id=c89b315a&scoped=true"
import script from "./CustomSortButton.vue?vue&type=script&lang=js"
export * from "./CustomSortButton.vue?vue&type=script&lang=js"
import style0 from "./CustomSortButton.vue?vue&type=style&index=0&id=c89b315a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c89b315a",
  null
  
)

export default component.exports